export function EmptyState() {
  return (
    <div className="alert alert-info empty-state">
      <p>Ask anything about EV registration trends — a city name month wise, a coordinate, or a comparison.</p>
      <p>Try:</p>
      <ul>
        <li>How many EVs are registered in Ahmedabad till August?</li>
        <li>What's the demand like within 100km of 22.30, 73.18?</li>
        <li>Is Vadodara a good candidate for a new charging station?</li>
        <li>Compare EV between the cities of Pune and Mumbai.</li>
      </ul>
    </div>
  );
}
